<template>
  <IconButtonComponent @click="toggleDarkMode">
    <MoonIcon v-if="isDark" />
    <SunIcon v-else />
  </IconButtonComponent>
</template>

<script setup>
import MoonIcon from '@/assets/icons/outline/MoonIcon.vue'
import SunIcon from '@/assets/icons/outline/SunIcon.vue'
import IconButtonComponent from '@/components/common/IconButtonComponent.vue'
import { ref, onMounted } from 'vue'

const isDark = ref(false)

const toggleDarkMode = () => {
  isDark.value = !isDark.value
  if (isDark.value) {
    document.documentElement.classList.add('dark')
    localStorage.setItem('darkMode', 'true')
  } else {
    document.documentElement.classList.remove('dark')
    localStorage.setItem('darkMode', 'false')
  }
}

onMounted(() => {
  if (localStorage.getItem('darkMode') === 'true') {
    isDark.value = true
    document.documentElement.classList.add('dark')
  }
})

</script>
